"use strict";
var ErrorObservable_1 = require('./ErrorObservable');
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/observable/throw.js